import { Box, Card, CardContent, Typography, Grid, Button } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { DCDistributorSummary } from '../../types/dc.types'

interface OrderDistributorSummaryProps {
  distributors: DCDistributorSummary[]
  onExportCSV: (distributorId: number | null) => void
}

export default function OrderDistributorSummaryCards({ distributors, onExportCSV }: OrderDistributorSummaryProps) {
  return (
    <Grid container spacing={2}>
      {distributors.map((d) => (
        <Grid item xs={12} sm={6} md={4} key={d.distributor_id || 'unknown'}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle1" fontWeight={600} noWrap>
                {d.distributor_name || 'Unknown Distributor'}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  {d.item_count} items
                </Typography>
                <Typography variant="body2" fontWeight={600} color="primary.main">
                  Rs. {(d.total_cost || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </Typography>
              </Box>
              <Button
                size="small"
                startIcon={<DownloadIcon />}
                onClick={() => onExportCSV(d.distributor_id)}
                sx={{ mt: 1 }}
                fullWidth
                variant="outlined"
              >
                Download CSV
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
